import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { useI18n, type StringKey } from '../lib/i18n';

const TABS: Array<{ to: string; key: StringKey; icon: ReactNode }> = [
  {
    to: '/', key: 'nav.card',
    icon: <rect x="2" y="5" width="20" height="14" rx="3" fill="none" stroke="currentColor" strokeWidth="1.6" />,
  },
  {
    to: '/history', key: 'nav.history',
    icon: <path d="M4 6h16M4 12h16M4 18h10" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />,
  },
  {
    to: '/rewards', key: 'nav.rewards',
    icon: <path d="M12 3.5l2.6 5.3 5.9.85-4.25 4.15 1 5.85L12 16.9l-5.25 2.75 1-5.85L3.5 9.65l5.9-.85z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />,
  },
  {
    to: '/garage', key: 'nav.garage',
    icon: <path d="M3 14l1.6-5A2 2 0 016.5 7.6h11A2 2 0 0119.4 9L21 14v4h-3v-2H6v2H3v-4z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />,
  },
  {
    to: '/profile', key: 'nav.profile',
    icon: <><circle cx="12" cy="8.5" r="3.2" fill="none" stroke="currentColor" strokeWidth="1.6" /><path d="M5 19.5c1.2-3.2 3.8-4.8 7-4.8s5.8 1.6 7 4.8" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></>,
  },
];

export function TabBar() {
  const { t } = useI18n();
  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 border-t border-line bg-surface/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-md">
      <div className="mx-auto flex max-w-md">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.to === '/'}
            className={({ isActive }) =>
              `flex flex-1 flex-col items-center gap-1 py-2.5 text-[0.62rem] font-medium transition-colors ${
                isActive ? 'text-brand' : 'text-ink-faint'
              }`
            }
          >
            <svg viewBox="0 0 24 24" className="h-6 w-6" aria-hidden>{tab.icon}</svg>
            {t(tab.key)}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
